module.exports = __webpack_public_path__ + "static/media/doe-logo.c6c18cd7.png";